import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmptyApplicationHandler from "../empty-application-handler";
import Select2 from "@Shared/components/inputs/select2";
import AddClientModal from "../../../../applications/application/applications-list/components/add-client-modal";
import UploadDocuments from "./file-tab/upload-documents";
import { LOAD_DOCUMENTS, LOAD_DOCUMENT_TYPES, UPLOAD_DOCUMENT_TO_CLASSIFICATION } from "@Broker/js/modules/clients/applications/documents/store/documents-actions";
import { mapActions, mapMutations } from "vuex";
import { isEmpty } from "lodash";
import { ADD_TIMELINE_ITEM } from "../../../store/board-mutations";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FileTab",
  components: {
    Select2,
    EmptyApplicationHandler,
    AddClientModal,
    UploadDocuments
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    username: {
      type: String,
      default: null
    },
    applications: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      actions: null,
      uploadActions: null,
      applicationId: isEmpty(this.applications) ? null : _Object$keys(this.applications)[0],
      modalData: {},
      uploadingDocument: false,
      uploadingSucceeded: true
    };
  },
  computed: {
    agentUsername() {
      return this.profile.owner.username;
    },
    mappedApplications() {
      const arr = [];
      for (const key in this.applications) {
        arr.push(_objectSpread({}, this.applications[key]));
      }
      return arr;
    },
    applicationSelectOptions() {
      return {
        placeholder: this.$t("file.messages.selectAnApplication"),
        allowClear: false
      };
    }
  },
  mounted() {
    if (this.applicationId) {
      this.loadDocuments();
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DocumentsStore", [LOAD_DOCUMENTS, LOAD_DOCUMENT_TYPES, UPLOAD_DOCUMENT_TO_CLASSIFICATION])), mapMutations("BoardStore", [ADD_TIMELINE_ITEM])), {}, {
    formatData(data) {
      return _mapInstanceProperty(data).call(data, app => {
        app.text = `${this.$t("application.applicationID")}: ${app.applicationId}`;
        app.id = app.applicationId;
        return app;
      });
    },
    handleApplicationChange({
      applicationId
    }) {
      this.applicationId = applicationId;
      if (this.actions) this.actions.applicationId = applicationId;
      if (this.uploadActions) this.uploadActions.applicationId = applicationId;
      this.loadDocuments();
    },
    resetModalData() {
      this.modalData = {};
    },
    handleCreateApplication() {
      this.modalData = {
        clientDetails: _objectSpread({}, this.profile),
        agentUsername: this.profile.owner.username,
        additional: false,
        clientProfileId: this.clientProfileId,
        method: "full-application-method",
        clientUsername: this.username
      };
      this.$refs.addClient.show();
    },
    async loadDocuments() {
      const promises = [this.LOAD_DOCUMENTS({
        clientUsername: this.username,
        applicationId: _parseInt(this.applicationId)
      }), this.LOAD_DOCUMENT_TYPES()];
      _Promise.all(promises);
    },
    async handleUploadDocuments({
      files,
      classification
    }) {
      this.uploadingDocument = true;
      const {
        withError,
        newDocuments
      } = await this.UPLOAD_DOCUMENT_TO_CLASSIFICATION({
        applicationId: this.applicationId,
        clientUsername: this.username,
        classification,
        files
      });
      if (withError) this.uploadingSucceeded = !withError;else {
        for (const file of newDocuments) {
          this.ADD_TIMELINE_ITEM({
            profileId: this.clientProfileId,
            newItem: {
              activityType: "file",
              applicationId: _parseInt(this.applicationId),
              name: file.fileName,
              classificationType: file.classificationType,
              numOfComments: 0,
              createdAt: file.createdAt,
              updatedAt: file.updatedAt,
              id: file.documentId
            }
          });
        }
      }
      this.uploadingDocument = false;
    }
  })
});